function MyButton() {
  return (
    <button>I'm a button</button>
  );
}

export default MyButton;